
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Layout, PrimaryButton, CartListItem } from '../components'
import { push } from 'connected-react-router'
import styled from 'styled-components'
// reducks
import { getProductsInCart } from '../reducks/users/selectors'
// mui
import List from '@material-ui/core/List'
import Button from '@material-ui/core/Button'

const CartList = () => {
    const dispatch = useDispatch()
    const selector = useSelector(state => state)
    const productsInCart = getProductsInCart(selector)

    const goToOrder = useCallback(()=>{
        dispatch(push('/order/confirm'))
    },[dispatch])
    const backToHome = useCallback(()=>{
        dispatch(push('/'))
    },[dispatch])

    return (
        <Layout>
            <div className='spacer-100' />
            <h2>ショッピングカート</h2>
            <div className='spacer-50' />

            {/* カート一覧 */}
            <ListWrapper>
                <List>
                    {productsInCart?.length > 0 && productsInCart.map(product => 
                        <CartListItem key={product.cartId} product={product} />
                    )}
                </List>
                {productsInCart.length > 0 
                // カートに商品がある場合
                ? (
                    <>
                        <div className='spacer-50' />
                        <PrimaryButton label='レジへ進む' operation={goToOrder} />
                    </>
                )
                // カートが空の場合
                : (
                    <>
                        <div className='spacer-100'/>
                        <p>カートの中は空です</p>
                        <div className='spacer-100'/>
                    </>
                )}
            </ListWrapper>
            <div className='spacer-25' />
            <div style={{textAlign:'center'}}>
                <Button onClick={backToHome}>ホームに戻る</Button>
            </div>
            <div className='spacer-100'/>
        </Layout>
    )
}

export default CartList

const ListWrapper = styled.div`
    width: 640px;
    margin: 0 auto;
    text-align: center;
    @media screen and (max-width:768px){
        width: 100%;
        padding: 0 20px;
    }
`